import { render, staticRenderFns } from "./HeaderSection.vue?vue&type=template&id=ffa4de94"
import script from "./HeaderSection.vue?vue&type=script&lang=js"
export * from "./HeaderSection.vue?vue&type=script&lang=js"
import style0 from "./HeaderSection.vue?vue&type=style&index=0&id=ffa4de94&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports